import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import EditorImg from 'lowcode/components/EditorImg';
import LRMessage from '../LRMessage';
import styles from './index.module.scss';

export default function SwiperCommon({ list = [], children }: { list: any[]; children?: any }) {
    return (
        <div className={styles.thecomp}>
            <Swiper
                className="swiper-box"
                modules={[Navigation, Pagination]}
                navigation={true}
                pagination={true}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {list.map((item: any, index: number) => {
                    return (
                        <SwiperSlide key={index}>
                            {item.isChildNode && item.ChildNodeB && <>{item.ChildNodeB}</>}
                            {!item.isChildNode && (
                                <div key={index} className="comp-item">
                                    <div className="comp-item-up-title">{item.upTitle}</div>
                                    <div className="comp-item-content">
                                        <EditorImg pc={item.pc} h5={item.h5} />
                                        {item.isChangeImg2 && <EditorImg className="comp-item-content-img2" pc={item.pc2} h5={item.h52} />}
                                    </div>
                                    <LRMessage lTitle={item.subtitle} rTitle={item.desc} rTips={item.tips} />
                                </div>
                            )}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
